import { useUser } from "@nju/data-access-portal-user";
import { capitalizeFirstLetterOfEachWord } from "@nju/utils";
import { Navigation } from "./Navigation";

export function NavigationWithUserContext() {
  const { firstName, isPersonVerified } = useUser();

  const title = isPersonVerified
    ? `cześć, ${capitalizeFirstLetterOfEachWord(firstName)}!`
    : `cześć, poznaj ofertę nju`;

  return <Navigation title={title} />;
}
